export default __webpack_public_path__ + "static/media/8_Intro.8a31075a.mp4";